import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import type { LocaleCode } from '@sshop/domain';

export interface I18nInitOptions {
  defaultLocale: LocaleCode;
  resources: Partial<Record<LocaleCode, Record<string, Record<string, string>>>>;
  /** Namespaces to register. Defaults to `['common']`. */
  namespaces?: readonly string[];
  /** Default namespace used by `t('key')` without a prefix. Defaults to `'common'`. */
  defaultNS?: string;
}

export async function initI18n(opts: I18nInitOptions) {
  const namespaces = opts.namespaces && opts.namespaces.length > 0 ? opts.namespaces : ['common'];
  await i18n.use(initReactI18next).init({
    lng: opts.defaultLocale,
    fallbackLng: 'ge',
    defaultNS: opts.defaultNS ?? 'common',
    ns: namespaces as string[],
    interpolation: { escapeValue: false },
    resources: opts.resources,
    react: { useSuspense: false },
  });
  return i18n;
}

export { useTranslation, Trans } from 'react-i18next';
export { default as i18nInstance } from 'i18next';
